import { TypeOrderEnum } from '@model/enum/type-order.enum';
import { Component, OnInit, Input } from '@angular/core';
import { AuthServer } from '@services/auth-server.service';
import { AppUtils } from '@utils/app.utils';
import { Constants } from '@utils/constants';
import { TimeInForceEnum } from '@model/enum/time-in-force.enum';

@Component({
  selector: 'app-orders-history-detail',
  templateUrl: './orders-history-detail.component.html'
})
export class OrdersHistoryDetailComponent implements OnInit {

  @Input() dataOrder: any;
  listHistoryOrder;
  loading: boolean;
  futureIndice: boolean;
  showStrategieOrder: boolean;
  showTypeStopOrder: boolean;
  orderValidity: string;

  constructor(
    private _authServer: AuthServer,
  ) {
    this.getStrategies();
  }

  ngOnInit() {
    this.loading = true;
    if (this.dataOrder) {
      this.showTypeStopOrder = this.dataOrder.type && this.dataOrder.type.toLowerCase() === TypeOrderEnum.STOP.toLowerCase() ? true : false;
      if (this.dataOrder.maturity) {
        this.dataOrder.maturity = this.dataOrder.maturity.substring(0, 10);
      }
      if (this.dataOrder.minQty) {
        this.dataOrder.minQty = AppUtils.numberToFormattedNumber(Number(this.dataOrder.minQty), 0);
      }
      if (this.dataOrder.quote.toLowerCase().indexOf('win') === 0 || this.dataOrder.quote.toLowerCase().indexOf('wdo') === 0 ||
        this.dataOrder.quote.toLowerCase().indexOf('dol') === 0 || this.dataOrder.quote.toLowerCase().indexOf('ind') === 0) {
        this.futureIndice = true;
      } else {
        this.futureIndice = false;
      }

      if (!this.dataOrder.timeInForce) {
        this.orderValidity = '-';
      } else if (this.dataOrder.timeInForce === TimeInForceEnum.GTD) {
        this.orderValidity = this.dataOrder.maturity;
      } else {
        const timeInForce = Constants.TIME_IN_FORCES.find(option => {
          return (option.webfeeder === this.dataOrder.timeInForce);
        });
        this.orderValidity = this.dataOrder.timeInForce + (timeInForce ? ` - ${timeInForce.desc}` : '');
      }

    }
    this._authServer.iNegotiation.getHistoryOrder(this.dataOrder.account, null, null, null, null, null, null, this.dataOrder.orderID)
      .subscribe((historyOrder: any) => {
        console.log("HISTORY", historyOrder);
        if (historyOrder && historyOrder.listBeans) {
          this.listHistoryOrder = this.convertValues(historyOrder.listBeans);
          // AppUtils.orderObjectAsc(this.listHistoryOrder, 'transactTime');
        }
        this.loading = false;
      });
  }

  getStrategies() {
    this.loading = true;
    this._authServer.iNegotiation.getStrategies()
      .subscribe(res => {
        this.showStrategieOrder = res && res.length > 1 ? true : false;
      }, () => {
        this.showStrategieOrder = false;
      });
  }

  convertValues(list: Array<any>): Array<any> {
    if (!Array.isArray(list)) {
      return [];
    }
    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      if (!item) continue;
      item.state = item.state && item.state.value && item.state.code ? AppUtils.getStatusName(item.state.value, item.state.code) : item.state?.value;
      item.quantityExecuted = item.quantityExecuted && item.quantityExecuted.value ? Number(item.quantityExecuted.value) : item.quantityExecuted?.value;
      item.quantityRemaining = item.quantityRemaining && item.quantityRemaining.value ? Number(item.quantityRemaining.value) : item.quantityRemaining?.value;
      item.quantitySupplied = item.quantitySupplied && item.quantitySupplied.value ? Number(item.quantitySupplied.value) : item.quantitySupplied?.value;
      item.price = item.price && item.price.value && item.mercado && item.mercado.code ? AppUtils.formatPriceBovespaAndBmfToString(item.price.value, item.mercado.code) : item.price?.value;
      if (item.transactTime && typeof item.transactTime.value === 'string' && item.transactTime.value.toString().trim().split(' ').length === 2) {
        const dateParts = item.transactTime.value.toString().trim().split(' ')[0].split('/');
        const timeParts = item.transactTime.value.toString().trim().split(' ')[1].split(':');
        item.transactTime = new Date(
          Number(dateParts[2]),
          Number(dateParts[1]) - 1,
          Number(dateParts[0]),
          Number(timeParts[0]),
          Number(timeParts[1]),
          Number(timeParts[2])
        );
      } else {
        item.transactTime = item.transactTime?.value;
      }
    }
    return list;
  }

}
